// import "./bootstrap";
import { createApp } from "vue";
import { createHead } from "@unhead/vue";
import vClickOutside from "click-outside-vue3";

import axios from "axios";
import App from "./App.vue";
import router from "./router.js";
import store from "./store/store";
import i18n from "./i18n";
import moshaVueToastifyEs from "mosha-vue-toastify";
import { BootstrapIconsPlugin } from "bootstrap-icons-vue";
import Dashly from "./helpers/dashly";
import GTM from "@/services/gtm";
// import { initMixpanel } from './analytics/mixpanel'

// initMixpanel()
const app = createApp(App);
const head = createHead();


app.config.globalProperties.axios = axios;

if (!window.location.host.includes("localhost")) {
    app.use(GTM);
}

app.use(head)
    .use(store)
    .use(i18n)
    .use(BootstrapIconsPlugin)
    .use(router)
    .use(vClickOutside)
    .use(moshaVueToastifyEs)
    .use(Dashly)
    .mount("#app");
